package com.merkost.handpass.admin.components

import androidx.compose.runtime.Composable
import com.merkost.handpass.sharedweb.components.WebTab
import com.merkost.handpass.sharedweb.components.WebTabs

data class AdminTab<T>(val key: T, val label: String, val countBadge: Long? = null)

@Composable
fun <T> AdminTabs(tabs: List<AdminTab<T>>, selected: T, onSelect: (T) -> Unit) {
    WebTabs(
        tabs = tabs.map { WebTab(key = it.key, label = it.label, countBadge = it.countBadge) },
        selected = selected,
        onSelect = onSelect,
    )
}
